import React from 'react';
import { Box } from '@material-ui/core';

import { Section } from 'components/Section';


export function TextSection(props: {
  description?: string,
  title: string,
  tooltip?: string,
}) {
  return (
    <Section title={props.title} tooltip={props.tooltip}>
      {props.description &&
        <Box>
          {props.description.split('\n').map((s, i) => <p key={i}>{s}</p>)}
        </Box>
      }
    </Section>
  );
}
